import * as React from "react";
import { useTranslation } from "react-i18next";
import KendoDataGrid from "../../components/kendoGridv2/KendoDataGrid";
import { candidateClient } from "../../client/candidateClient";
import { GenderFilterCell } from "../../components/sys-common/GenderFilterCell";

/**@type {import("@progress/kendo-react-grid").GridColumnProps[]} */
const initialColumns = [
  {
    field: "ad",
    title: "jobApplication.personalInfo.name",
  },
  {
    field: "soyad",
    title: "jobApplication.personalInfo.lastname",
  },
  {
    field: "cinsiyet",
    title: "jobApplication.personalInfo.gender",
    tKey: "gender_data",
    dataItemKey: "value",
    textField: "text",
    filterCell: GenderFilterCell,
    ignoreCase: true,
  },
  {
    field: "doguM_TARIHI",
    title: "jobApplication.personalInfo.birthDate",
    filter: "date",
  },
  {
    field: "ceP_TEL_NO",
    title: "jobApplication.personalInfo.phone",
  },
  {
    field: "il",
    title: "jobApplication.address.city",
    filterable: false,
  },
  {
    field: "ilce",
    title: "jobApplication.address.district",
    tKey: "SAKARYA_ILCELER_DATA",
  },
  {
    field: "aciK_ADRES",
    title: "jobApplication.address.fullAddress",
  },
  {
    field: "askerlik",
    title: "jobApplication.military.status",
    hidden: true,
    tKey: "military_status_data",
  },
  {
    field: "g_LICENSE",
    title: "jobApplication.g_class",
    type: "boolean",
  },
  {
    field: "mezuniyet",
    title: "jobApplication.education.level",
    tKey: "education_level_data",
  },
  {
    field: "bolum",
    title: "jobApplication.education.department",
  },
  {
    field: "sertifikalar",
    title: "jobApplication.certificates.title",
    hidden: true,
  },
  {
    field: "vardiyalI_CALISIR",
    title: "jobApplication.workPreferences.canWorkShifts",
    type: "boolean",
  },
  {
    field: "akrabasI_VAR",
    title: "jobApplication.relatives.hasRelatives",
    type: "boolean",
  },
  {
    field: "akrabA_YAKINLIK",
    title: "jobApplication.relatives.relation",
  },
  {
    field: "yuksektE_CALISIR",
    title: "jobApplication.workPreferences.canWorkAtHeight",
    hidden: true,
    type: "boolean",
  },
    {
    field: "bolumler",
    title: "jobApplication.department",
  },
  {
    field: "upD_DATE",
    title: "jobApplication.upd_date",
    hidden: true,
    filter: "date",
  },
  {
    field: "adaY_GORUSME_DURUMU",
    title: "jobApplication.candidate.status.interviewStatus",
    tKey: "jobApplication.interview_status_data",
    dataItemKey: "value",
    textField: "text",
  },
  {
    field: "i_K_ACIKLAMA",
    title: "jobApplication.candidate.status.hrNotes",
  },
  {
    field: "tekraR_ADAY_ID",
    title: "Önceki Başvuru ID",
  },
  {
    field: "birincI_IS_AYRILMA_NEDEN",
    title: "1. İş Ayrılma Nedeni",
  },
  {
    field: "birincI_IS_BAS_TAR",
    title: "1. İş Başlangıç Tarihi",
    filter: "date",
  },
  {
    field: "birincI_IS_BIT_TAR",
    title: "1. İş Bitiş Tarihi",
    filter: "date",
  },
  {
    field: "birincI_IS_FIRMA",
    title: "1. İş Firma",
  },
  {
    field: "birincI_IS_YAPILAN_IS",
    title: "1. İş",
  },
  {
    field: "ikincI_IS_AYRILMA_NEDEN",
    title: "2. İş Ayrılma Nedeni",
  },
  {
    field: "ikincI_IS_BAS_TAR",
    title: "2. İş Başlangıç Tarihi",
    filter: "date",
  },
  {
    field: "ikincI_IS_BIT_TAR",
    title: "2. İş Bitiş Tarihi",
    filter: "date",
  },
  {
    field: "ikincI_IS_FIRMA",
    title: "2. İş Firma",
  },
  {
    field: "ikincI_IS_YAPILAN_IS",
    title: "2. İş",
  },
];

export default function CandidateDataGrid() {
  const { t } = useTranslation();
  return (
    <KendoDataGrid
      axios={candidateClient}
      uri="get-list-by-filter"
      columns={initialColumns}
      dataState={{ take: 10, sort: [{ field: "upD_DATE", dir: "desc" }] }}
      columnUniqueKey="candidate_columns.v2"
      title={t("dmy_ise_alim")}
      hrefProp={"dkN_DMY_ADAY_ID"}
      gridButtons={[{ title: t("detail") }]}
      dataItemKey="dkN_DMY_ADAY_ID"
    />
  );
}
